import {
  GET_PROVIDER_PORTAL_DETAIL,
  GET_VIEW_HISTORY,
  VIEW_DETAIL_PAGE,
  GET_FACILITY_TEST,
  GET_TESTDETAIL_NEW_PAGE,
  GET_TESTDETAIL_UPDATE_PAGE,
  GET_PACKAGEDETAIL_NEW_PAGE,
  GET_PACKAGEDETAIL_UPDATE_PAGE,
  GET_DETAIL_TYPE,
  GET_TESTDETAIL_NEW_PAGE_IBU,
  GET_TESTDETAIL_UPDATE_PAGE_IBU,
  GET_PACKAGEDETAIL_NEW_PAGE_IBU,
  GET_PACKAGEDETAIL_UPDATE_PAGE_IBU,
  GET_PROVIDER_UPLOAD_DOC,
} from "../../Utils/types";

const initialState = {
  getProviderPortalDetails: [],
  getViewDetailPage: null,
  getViewHistory: [],
  getFacilityReason: [],
  getTestDetailUpdatePage: [],
  getTestDetailNewPage: [],
  getPackageDetailUpdatePage: [],
  getPackageDetailNewPage: [],
  getDetailType: [],
  getTestDetailUpdatePageIBU: [],
  getTestDetailNewPageIBU: [],
  getPackageDetailUpdatePageIBU: [],
  getPackageDetailNewPageIBU: [],
  getProviderUploadDoc:[],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_PORTAL_DETAIL:
      return {
        ...state,
        getProviderPortalDetails: action.payload,
      };
    case VIEW_DETAIL_PAGE:
      return {
        ...state,
        getViewDetailPage: action.payload,
      };
    case GET_TESTDETAIL_NEW_PAGE:
      return {
        ...state,
        getTestDetailNewPage: action.payload,
      };
    case GET_TESTDETAIL_UPDATE_PAGE:
      return {
        ...state,
        getTestDetailUpdatePage: action.payload,
      };
    case GET_PACKAGEDETAIL_NEW_PAGE:
      return {
        ...state,
        getPackageDetailNewPage: action.payload,
      };
    case GET_PACKAGEDETAIL_UPDATE_PAGE:
      return {
        ...state,
        getPackageDetailUpdatePage: action.payload,
      };
    case GET_VIEW_HISTORY:
      return {
        ...state,
        getViewHistory: action.payload,
      };
    case GET_FACILITY_TEST:
      return {
        ...state,
        getFacilityReason: action.payload,
      };
    case GET_DETAIL_TYPE:
      return {
        ...state,
        getDetailType: action.payload,
      };
    case GET_TESTDETAIL_NEW_PAGE_IBU:
      return {
        ...state,
        getTestDetailNewPageIBU: action.payload,
      };
    case GET_TESTDETAIL_UPDATE_PAGE_IBU:
      return {
        ...state,
        getTestDetailUpdatePageIBU: action.payload,
      };
    case GET_PACKAGEDETAIL_NEW_PAGE_IBU:
      return {
        ...state,
        getPackageDetailNewPageIBU: action.payload,
      };
    case GET_PACKAGEDETAIL_UPDATE_PAGE_IBU:
      return {
        ...state,
        getPackageDetailUpdatePageIBU: action.payload,
      };
      case GET_PROVIDER_UPLOAD_DOC:
        return {
          ...state,
          getProviderUploadDoc: action.payload,
        };
    default:
      return state;
  }
};
